export default function isEdge(): boolean {
  return typeof navigator !== 'undefined' && /Edg/.test(navigator?.userAgent);
}
